import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Angular2CsvComponent } from "angular2-csv";
/**
 * Service File
 */
import { GetAllReceiptsService } from "../../../services/receipts/getAllReceipts/get-all-receipts.service";
import { GetOfferingTypeService } from "../../../services/receipts/getOfferingType/get-offering-type.service"
import { SearchEventService } from "../../../services/search/searchEvent/search-event.service";
import { ModeService } from "../../../services/search/getMode/mode.service";
import { GetBankService } from "../../../services/receipts/getBank/get-bank.service"
import { OfferingTypeEventBasedService } from "../../../services/search/offeringTypeEventBased/offering-type-event-based.service";
import { ModeAndMediumService } from "../../../services/receipts/modeAndMedium/mode-and-medium.service";
import { YearlyReportDataService } from "../../../services/receipts/yearlyReportData/yearly-report-data.service"

import { DatepickerOptions } from 'ng2-datepicker';
import { from } from 'rxjs';

declare var $: any;
@Component({
  selector: 'app-receipts',
  templateUrl: './receipts.component.html',
  styleUrls: ['./receipts.component.less']
})
export class ReceiptsComponent implements OnInit {
  @HostListener("window:scroll", [])
  onWindowScroll() {
    var bodypos = document.documentElement.scrollHeight || document.body.scrollHeight;
    var windowh = document.documentElement.clientHeight || document.body.clientHeight;
    bodypos = bodypos - windowh;
    var windowpos = document.documentElement.scrollTop || document.body.scrollTop;;
    var persentage = Math.round((windowpos / bodypos) * 100);
    if (
      Math.round(persentage) > 95 &&
      this.NextCall == 1 &&
      this.search.search_column == ""
    ) {
      this.StartRecord = +this.StartRecord + +this.lengthOfRecord
      this.dqloader = true;
      this.getAllReceipts(this.StartRecord, this.lengthOfRecord);
      this.NextCall = 0;
    }

  }

  /**
   * For CSV Download 
   */
  @ViewChild(Angular2CsvComponent, null) csvComponent: Angular2CsvComponent;
  options: any = {}
  data: any = []
  public fileName: any
  public exportButtonLoading: Boolean = false

  /** Variable Declaration */

  public StartRecord: number = 0
  public lengthOfRecord: Number = 10
  public NextCall: any;
  public dqloader: Boolean = false;
  // public tableLoader: Boolean = true;
  public skeletonLoader: Boolean = true;
  public allReceiptDate: any = []
  public filterKey: any = []


  /** filter variable and loader var */
  public offeringTypeData: any
  public bankData: any
  public eventList: any
  public modeData: any
  public offeringTypeEventBasedData: any
  public modeAndMediumData: any

  public eventBasedOfferingType: Boolean = false
  public modeBasedSearch: Boolean = false

  public offeringTypeSkeleton = true
  public selectEventSkeleton = true
  public modeSkeleton = true
  public bankSkeleton = true
  public selectReceiptEventSkeleton = true
  public offeringTypeEventBasedSkeleton: Boolean = true
  public modeBasedSkeleton: Boolean = true
  public submitLoading: Boolean = false

  public isPrint: Boolean = false
  public printButtonLoad: Boolean = false
  public printLetterButtonLoad: Boolean = false

  public details: any

  public disableXLSXButton: Boolean = true
  public XLSXButtonLoader: Boolean = false
  public XLSXData: any = []

  /**
 * For Date picker options
 */
  datePickerOptions: DatepickerOptions = {
    minYear: 1970,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday 
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  public order: any = {
    order_column: "rcpt.created_time",
    order_direct: "desc"
  }

  public query: any = {
    fromDate: null,
    toDate: null,
    offerType: 0,
    bank: 0,
    mode: 0,
    amtGreater: 0,
    amtLesser: 0,
    receiptEvent: 0,
    offeringTypeEventBased: 0,
  }

  public toSearch: Boolean = false

  public search: any = {
    search: "",
    search_column: ""
  }

  constructor(
    private GetAllReceiptsService: GetAllReceiptsService,
    private GetOfferingTypeService: GetOfferingTypeService,
    private SearchEventService: SearchEventService,
    private ModeService: ModeService,
    private OfferingTypeEventBasedService: OfferingTypeEventBasedService,
    private ModeAndMediumService: ModeAndMediumService,
    private GetBankService: GetBankService,
    private YearlyReportDataService: YearlyReportDataService
  ) { }

  async ngOnInit() {
    await this.getAllReceipts(0, this.lengthOfRecord)
    this.skeletonLoader = false
    await this.getFilterKeyValue()
    setTimeout(function () {
      $(`.searchColumn`).selectpicker('refresh');
    }, 100)
  }

  async getSearchColumn(ele) {

    if (ele != "") {
      this.toSearch = true
      this.search.search_column = ele
      $('#search').val('');
    } else {
      this.toSearch = false
    }
  }

  async cancelSearch() {
    this.toSearch = false
    this.search.search_column = ""
    this.search.search = ""
    setTimeout(function () {
      $(`.searchColumn`).selectpicker('refresh');
    }, 100)
    this.allReceiptDate = []
    this.StartRecord = 0
    this.lengthOfRecord = 10
    this.getAllReceipts(this.StartRecord, this.lengthOfRecord)
  }

  async searchBy() {
    this.search.search = $("#search").val()
    this.allReceiptDate = []
    this.StartRecord = 0
    this.lengthOfRecord = 10
    this.getAllReceipts(this.StartRecord, this.lengthOfRecord)
    this.NextCall = 0
  }

  async filterWithDetails(ele) {
    this.submitLoading = true
    // $("[data-id='SearchColumn']").prop('disabled', true);
    this.query = {
      fromDate: ele.fromDate == null ? null : moment(ele.fromDate).format("YYYY-MM-DD"),
      toDate: ele.toDate == null ? null : moment(ele.toDate).format("YYYY-MM-DD"),
      offerType: ele.offeringType == "" ? 0 : ele.offeringType.toString(),
      bank: ele.bank == "" ? 0 : ele.bank.toString(),
      mode: ele.mode == "" ? 0 : parseInt(ele.mode),
      modeAndMedium: (ele.modeAndMedium == "" || ele.modeAndMedium == undefined) ? 0 : parseInt(ele.modeAndMedium),
      amtGreater: ele.amtGreater == "" ? 0 : parseInt(ele.amtGreater),
      amtLesser: ele.amtLesser == "" ? 0 : parseInt(ele.amtLesser),
      receiptEvent: ele.receiptEvent == "" ? 0 : parseInt(ele.receiptEvent),
      offeringTypeEventBased: ele.offeringTypeEventBased == undefined ? 0 : parseInt(ele.offeringTypeEventBased),
    }

    if (ele.offeringType != "") {
      this.disableXLSXButton = false
      let fromDate = ele.fromDate == null ? '' : moment(ele.fromDate).format("YYYY-MM");
      let toDate = ele.toDate == null ? '' : moment(ele.toDate).format("YYYY-MM");
      this.getReportData(ele.offeringType.toString(), fromDate, toDate)

    }

    this.allReceiptDate = []
    this.StartRecord = null
    this.lengthOfRecord = null
    this.getAllReceipts(this.StartRecord, this.lengthOfRecord)
    this.submitLoading = false
  }


  async getAllReceipts(start, length) {
    this.dqloader = true;
    this.isPrint = false
    let response: any = await this.GetAllReceiptsService.getAllReceipts(
      this.search,
      start,
      length,
      this.order,
      this.query
    );
    if (response.data.length != 0) {
      response.data.forEach(element => {
        this.allReceiptDate.push(element);
      });
      this.exportToCSVOptions()
      this.NextCall = 1;
      this.dqloader = false;
    } else {
      this.NextCall = 0;
      this.dqloader = false;
    }
  }

  async exportToCSVOptions() {
    let today = new Date();
    this.fileName = "BPM_Receipt_List" + today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '_' + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();;
    this.options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: ["Partner Id", "Receipt Id", "Full Name", "Email Id", "Primary Mobile Number", "Address Line 1", "Address Line 2", "Address Line 3", "Ambassador Name", "Amount In Words", "Bank Medium", "Bank Name", "Cash Medium", "Chq DD Number", "City", "Country", "Created Time", "Depos_Transf DD Chq Issue Date", "District", "Drawee Bank", "Event Name", "Gateway Name", "MO Trans Date", "Neft Rtgs Ref Number", "Offering Types", "Payment Gate Trans Date", "Pin code", "Province", "Receipt Date", "Receipt Disp Number", "Received Medium Id", "Received Mode", "Remarks", "Roles", "Staff_Name", "State Name", "Total Amount"],
      showTitle: false,
      title: 'BPM Receipt List',
      useBom: false,
      removeNewLines: true,
      keys: ["partner_id", "receipt_id", "full_name", "email_id", "primary_mobile_no", "address_line1", "address_line2", "address_line3", "ambasstor_name", "amt_in_words", "bank_medium", "bank_name", "cash_medium", "chq_dd_num", "city", "country_name", "created_time", "depos_transf_dd__chq_issue_date", "district", "drawee_bank", "event_name", "gateway_name", "mo_trans_date", "neft_rtgs_ref_num", "offering_types", "payment_gate_trans_date", "pincode", "province", "receipt_date", "receipt_disp_num", "received_medium_id", "received_mode", "remarks", "roles", "staff_name", "state_name", "total_amount"]
    };
    this.data = this.allReceiptDate
  }


  async exportToCSV() {
    this.exportButtonLoading = true
    setTimeout(() => {
      this.csvComponent.onDownload();
      this.exportButtonLoading = false
    }, 1000)
  }

  async getFilterKeyValue() {
    // let response: any = await this.GetAllReceiptsService.getAllReceipts(
    //   0,
    //   1,
    //   this.order
    // );
    // this.filterKey = response.keys
    this.filterKey = ["RECEIPT_ID",
      "PARTNER_ID",
      "AMBASSADOR_ID",
      "RECEIPT_DATE",
      "RECEIVED_MODE_ID",
      "REMARKS",
      "TOTAL_AMOUNT",
      "CREATED_TIME",
      "MODIFIED_TIME",
      "CREATED_BY",
      "MODIFIED_BY",
      "RECEIPT_DISP_NUM"]
  }

  async getOrderBy(value) {
    this.order.order_column = "rcpt." + value
    $(".orderColumn").each(function () {
      $(this).change(function () {
        $(".orderColumn").prop('checked', false);
        $(this).prop('checked', true);
      });
    });
  }

  async getTotalLength(value) {
    this.lengthOfRecord = value
    this.allReceiptDate = []
    this.StartRecord = 0
    this.getAllReceipts(this.StartRecord, this.lengthOfRecord)
  }

  async getAscendingDate() {
    this.order.order_direct = "asc"
    this.allReceiptDate = []
    this.dqloader = true
    this.getAllReceipts(this.StartRecord, this.lengthOfRecord)
  }

  async getDescendingDate() {
    this.order.order_direct = "desc"
    this.allReceiptDate = []
    this.dqloader = true
    this.getAllReceipts(this.StartRecord, this.lengthOfRecord)
  }

  async openSideFilter() {
    document.getElementById("mySidebar").style.width = "300px";
    document.getElementById("main").style.marginRight = "250px";

    await this.getOfferingType()
    await this.getEventLists()
    await this.getMode()
    await this.getBank()
    let root = this
    setTimeout(function () {
      root.offeringTypeSkeleton = false
      root.selectEventSkeleton = false
      root.modeSkeleton = false
      root.selectReceiptEventSkeleton = false
      root.bankSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.offeringType`).selectpicker('refresh');
      $(`.event`).selectpicker('refresh');
      $(`.mode`).selectpicker('refresh');
      $(`.bank`).selectpicker('refresh');
    }, 100)

  }

  async getBank() {
    let data = await this.GetBankService.GetBank()
    this.bankData = data.data
  }

  async getOfferingType() {
    let data = await this.GetOfferingTypeService.GetOfferingType()
    this.offeringTypeData = data.data
  }

  async getEventLists() {
    let event = await this.SearchEventService.getEventList()
    this.eventList = event.data
  }

  async getMode() {
    let data = await this.ModeService.getMode()
    this.modeData = data.data
  }

  async GetModeAndMedium(value) {
    if (value != "") {
      this.modeBasedSearch = true
      this.modeBasedSkeleton = true
      await this.modeBasedSelectionBoxRefresh(value)
    } else {
      this.modeBasedSearch = false
    }
  }

  async modeBasedSelectionBoxRefresh(id) {
    await this.getModeAndMedium(id)
    let root = this
    setTimeout(function () {
      root.modeBasedSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.modeAndMedium`).selectpicker('refresh');
    }, 100)
  }

  async getModeAndMedium(id) {
    let data = await this.ModeAndMediumService.GetModeAndMedium(id)
    this.modeAndMediumData = data.data
  }

  async getEventId(value) {
    if (value != "") {
      this.eventBasedOfferingType = true
      this.offeringTypeEventBasedSkeleton = true
      await this.offeringTypeEventBasedSelectionBoxRefresh()
    } else {
      this.eventBasedOfferingType = false
    }
  }

  async offeringTypeEventBasedSelectionBoxRefresh() {
    await this.getOfferingTypeEventBased()
    let root = this
    setTimeout(function () {
      root.offeringTypeEventBasedSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.offeringTypeEventBased`).selectpicker('refresh');
    }, 100)
  }

  async getOfferingTypeEventBased() {
    let data = await this.OfferingTypeEventBasedService.getOfferingTypeEvent()
    this.offeringTypeEventBasedData = data.data
  }

  keyPressEvent(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar))) {
      event.preventDefault();
    }
  }

  async getReportData(id, fromDate, toDate) {
    let result = await this.YearlyReportDataService.GetReportData(id, fromDate, toDate)
    this.XLSXData = result.data
  }

  async exportXLSXReport() {
    this.XLSXButtonLoader = true
    await this.YearlyReportDataService.generateExcel(this.XLSXData)
    this.XLSXButtonLoader = false
  }

  async closeSideFilter() {
    //   setTimeout(function () {
    //   $("[data-id='SearchColumn']").prop('disabled', false);
    //   $(`.searchColumn`).selectpicker('refresh');
    // }, 100)
    this.query = {
      fromDate: null,
      toDate: null,
      offerType: 0,
      bank: 0,
      mode: 0,
      amtGreater: 0,
      amtLesser: 0,
      receiptEvent: 0,
      offeringTypeEventBased: 0,
    }

    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
  }

  // async printReceipt(){
  // this.isPrint = true
  // this.printButtonLoad = true
  // }

  async printReceipt() {
    $("app-print-receipt").css("display", "block");
    $("app-print-letter").css("display", "none");
    $("app-pdf-receipt").css("display", "none");
    window.print()
  }

  async printLetter() {
    $("app-print-letter").css("display", "block");
    $("app-print-receipt").css("display", "none");
    $("app-pdf-receipt").css("display", "none");
    window.print()
  }

  async pdfReceipt() {
    $("app-pdf-receipt").css("display", "block");
    $("app-print-receipt").css("display", "none");
    $("app-print-letter").css("display", "none");
    window.print()
  }

  async outToParentLetter(e) {
    if (e == 'success') {
      window.print()
      this.printLetterButtonLoad = false
      // this.isPrint = false
    }
  }

  async outToParent(e) {
    if (e == 'success') {
      window.print()
      this.printButtonLoad = false
      // this.isPrint = false
    }
  }

  async viewDetails(data) {
    $("#receiptDetails").modal("show");
    this.details = data
  }

  async moveRight() {
    event.preventDefault();
    $(".table-responsive").animate(
      {
        scrollLeft: "+=1000px"
      },
      "slow"
    );
  }

  async moveLeft() {
    event.preventDefault();
    $(".table-responsive").animate(
      {
        scrollLeft: "-=1000px"
      },
      "slow"
    );
  }

}
